const Emoji = {
  slightlySmilingFace: '\uD83D\uDE42',
  neutralFace: '\uD83D\uDE10',
  worriedFace: '\uD83D\uDE1F',
};

// eslint-disable-next-line import/prefer-default-export
export { Emoji };
